import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57675410"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "logo",
  src: "/logo_large.png",
  alt: "TBCompanion logo"
}
const _hoisted_3 = { class: "bubble" }
const _hoisted_4 = { class: "bubble-top" }
const _hoisted_5 = { class: "bubble-center" }
const _hoisted_6 = { class: "bubble-bottom" }
const _hoisted_7 = { class: "infoblock" }
const _hoisted_8 = { href: "/about" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = {
  href: "https://play.google.com/store/apps/details?id=app.tbcompanion",
  target: "_blank"
}
const _hoisted_11 = {
  href: "https://apps.apple.com/us/app/tb-companion/id1556445437",
  target: "_blank"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bannerimage",
  src: "/banner.png",
  alt: "banner"
}, null, -1))

export function render(_ctx, _cache) {
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_Language = _resolveComponent("Language")
  const _component_el_image = _resolveComponent("el-image")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navigation),
    _createVNode(_component_Language),
    _createVNode(_Transition, { name: "el-fade-in-linear" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [
          [_vShow, _ctx.showLogo]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "el-fade-in-linear" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_image, {
              class: "bubble-top",
              src: "/bubble_top.png"
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.bubbleText), 513), [
              [_vShow, _ctx.bubbleText.length > 0]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_image, {
              class: "bubble-bottom",
              src: "/bubble_bottom.png"
            })
          ])
        ], 512), [
          [_vShow, _ctx.showBubble]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "el-zoom-in-bottom" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_el_image, {
          class: "panda",
          src: "/1_happy.png"
        }, null, 512), [
          [_vShow, _ctx.showPanda]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "el-zoom-in-bottom" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_el_image, {
          class: "bear",
          src: "/2_happy.png"
        }, null, 512), [
          [_vShow, _ctx.showPanda && _ctx.windowWidth > 500]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "el-zoom-in-bottom" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_el_image, {
          class: "hippo",
          src: "/3_happy.png"
        }, null, 512), [
          [_vShow, _ctx.showPanda && _ctx.windowWidth > 1000]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "el-zoom-in-bottom" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_el_image, {
          class: "tiger",
          src: "/4_happy.png"
        }, null, 512), [
          [_vShow, _ctx.showPanda && _ctx.windowWidth > 1000]
        ])
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _createElementVNode("a", _hoisted_8, [
        _createVNode(_component_el_image, {
          class: "logo",
          src: "/logo_large.png",
          alt: "TBCompanion logo"
        })
      ]),
      _hoisted_9,
      _createElementVNode("a", _hoisted_10, [
        _createVNode(_component_el_image, {
          class: "badge",
          src: "/google-play.png"
        })
      ]),
      _createElementVNode("a", _hoisted_11, [
        _createVNode(_component_el_image, {
          class: "badge",
          src: "/app-store.svg"
        })
      ])
    ], 512), [
      [_vShow, _ctx.showInfo]
    ]),
    _hoisted_12
  ]))
}